import React, { useState, useEffect } from "react";
// import 'react-pagination-bar/dist/index.css'
import "./ReportCss/Report1.css"
// import "react-data-export";

// import "file-saver"
// import XSLX from "sheetjs-style"
// import FileSaver from "file-saver";

import ReportTable from '../../Components/Global/ReportTable'
// import { SignalCellularNullRounded } from "@mui/icons-material";


const Report1 = (props) => {


    const {cntrct, cntComp, currentKey, reportData, setData, handleTab} = props
    //, reportParams, ReportParamsSet, ColsParams, ColsParamsSet

//  ColsParamsSet( !ColsParams ? [
    var ColsParams =[
        { Id: 'bld', Name: 'בניין', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 20},
        // { Id: 'flr', Name: 'קומה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 40},
        { Id: 'app', Name: 'דירה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 20},
        { Id: 'aliasName', Name: 'לקוח', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
        { Id: 'cellular', Name: 'פלאפון', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 35},
        { Id: 'statusCust', Name: 'סטטוס', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 30},
        { Id: 'docNum', Name: 'הזמנה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: [], Spcwidth: 30},
        { Id: 'totalRdr', Name: 'פתוח בהזמנה', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 40},
        { Id: 'totalDln', Name: 'פתוח במשלוח', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 40},
        // { Id: 'totalRdn', Name: 'פתוח בהחזרה', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 60},
        { Id: 'totalInv', Name: 'חשבונית', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 40},
        { Id: 'total', Name: 'סך לדירה', AddFilter: false, IsSumerize: true, Sumerize: 0, Spcwidth: 40},
        { Id: 'signQtn', Name: 'הזמנה חתומה', LinkImg: "/images/icons8-pdf-24.png", Spcwidth: 30, Title: 'docNum' },
       // { Id: 'path2', Name: 'פריסה', Spcwidth: 30, DisplayJustHasVal: true},
       // { Id: 'dtls', Name: 'פירוט', ConstVal: '...', Spcwidth: 15},
        // { Id: 'createActv', Name: 'שדר', TypeCol: 'CheckBox'},
        ];// :ColsParams);

     // ReportParamsSet( !reportParams?  {NumRowsPerPage: window.innerHeight / 25, FreeSearch: ''} : reportParams );
     var reportParams = {NumRowsPerPage: window.innerHeight / 25, FreeSearch: ''} ;

//https://webservice.tuboul.co.il:5678

    //const url = 'https://proxy.tuboul.co.il/GetRpt1PA?cntrctNum=' + cntrct + '&comp=' + cntComp + '';
    const url = '/GetRpt1PA?cntrctNum=' + cntrct + '&comp=' + cntComp + '';
   
//   useEffect(() => {
//     loadData();
//   }, [cntrct])


  
//   async function loadData() {
//     setLoadingStt('Loading');
//     setDataR([]);
//     setDataBefFilter([]);
//     // let copySumTotal = { totalRdr: 0, totalDln: 0, totalInv: 0, total: 0 };
//     // setSumTotal(copySumTotal);
//     // setDataByCol({ lstbld: [], lstflr: [], lstapp: [], lstaliasName:[], lstcellular:[],lstdocNum:[], lsttotalRdr:[], lsttotalDln:[], lsttotalInv:[], lsttotal:[] });
//     // setSelected({ lstbld: [], lstflr: [], lstapp: [], lstaliasName:[], lstcellular:[],lstdocNum:[], lsttotalRdr:[], lsttotalDln:[], lsttotalInv:[], lsttotal:[] });


//     var colParams = [
//         { Id: 'bld', Name: 'בניין', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
//         { Id: 'flr', Name: 'קומה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
//         { Id: 'app', Name: 'דירה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
//         { Id: 'aliasName', Name: 'לקוח', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
//         { Id: 'cellular', Name: 'פלאפון', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
//         { Id: 'docNum', Name: 'הזמנה', AddFilter: true, IsSumerize: false, AllVals: [], SelectedVals: []},
//         { Id: 'totalRdr', Name: 'פתוח בהזמנה', AddFilter: false, IsSumerize: true, Sumerize: 0},
//         { Id: 'totalDln', Name: 'פתוח במשלוח', AddFilter: false, IsSumerize: true, Sumerize: 0},
//         { Id: 'totalInv', Name: 'חשבונית', AddFilter: false, IsSumerize: true, Sumerize: 0},
//         { Id: 'total', Name: 'סך לדירה', AddFilter: false, IsSumerize: true, Sumerize: 0},
//         ];

//         console.log(colParams);

//     try {
//       const url = 'http://82.80.69.108:5678/ContractData/GetRpt1PA?cntrctNum=' + cntrct + '&comp=' + cntComp + '';
//       await fetch(url)
//         .then((response) => response.json())
//          .then((res) => {
//         //   let copySumTotal = { totalRdr: 0, totalDln: 0, totalInv: 0, total: 0 }
//           res.map((item) => {

//             colParams.map((col) => {
//                 if(col.IsSumerize)
//                      col.Sumerize += Number(item[col.Id].replace(/,/g, ''))
//               });


//             // copySumTotal.totalRdr += Number(item.totalRdr.replace(/,/g, ''))
//             // copySumTotal.totalDln += Number(item.totalDln.replace(/,/g, ''))
//             // copySumTotal.totalInv += Number(item.totalInv.replace(/,/g, ''))
//             // copySumTotal.total += Number(item.total.replace(/,/g, ''))
//           })
//         //   setSumTotal(copySumTotal);
//            setDataR(res);
//            setDataBefFilter(res);
//            setCount(res.length);
//         //   debugger;

//         //   setDataByCol({ lstbld: FillCombo(res, "bld"), lstflr: FillCombo(res, "flr"), lstapp: FillCombo(res, "app")
//         //   , lstaliasName: FillCombo(res, "aliasName") 
//         //   , lstcellular:FillCombo(res, "cellular") ,lstdocNum:FillCombo(res, "docNum") , lsttotalRdr:FillCombo(res, "totalRdr") 
//         //   , lsttotalDln:FillCombo(res, "totalDln") , lsttotalInv:FillCombo(res, "totalInv") , lsttotal:FillCombo(res, "total")  });

//           colParams.map((item) => {
//             if(item.AddFilter)
//                  item.AllVals = FillCombo(res, item.Id);
//           });
//           console.log('after fill');
//           console.log(colParams);

//           SetCols(colParams);
//          })
//         .catch((error) => { console.log('error-- ' + error); setLoadingStt('error ' + error); })
//         .finally(() => { console.log("---" + data); setLoadingStt(''); });
//     }
//     catch
//     {
//       debugger;
//       //  setDataBefFilter(data);
//     }
//     // debugger;
//   }

  
//   const handleSort = (uid) => {

//     var sortedData = sortArray(data, orderDirection, uid);
//     setDataR(sortedData);
//     setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
//   };
  
//   const sortArray = (arr, orderBy, uid) => {
 
    
//     switch (orderBy) {
//       case "asc":
//       default:
//         if(uid.includes("qty") || uid.includes("total"))
//         {
//           return arr.sort((a, b) =>
//           Number(a[uid].replace(/,/g, '')) > Number(b[uid].replace(/,/g, '')) ? 1 
//                     :  Number(b[uid].replace(/,/g, '')) > Number(a[uid].replace(/,/g, '')) ? -1 : 0 );
//         }
//         else if(uid.toUpperCase().includes("DATE"))
//        {
//         return arr.sort((a, b) =>
//         Date(a[uid]) > Date(b[uid]) ? 1 
//         :  Date(b[uid]) > Date(a[uid]) ? -1 : 0 );
//        }
//        else
//        {
//           return arr.sort((a, b) =>
//           a[uid] > b[uid] ? 1 :  b[uid] > a[uid] ? -1 : 0 );
//        }
//       case "desc":
//         if(uid.includes("qty") || uid.includes("total") || uid.includes("Qty"))
//         {
//         return arr.sort((a, b) =>
//         Number(a[uid].replace(/,/g, '')) < Number(b[uid].replace(/,/g, '')) ? 1 
//                   :  Number(b[uid].replace(/,/g, '')) < Number(a[uid].replace(/,/g, '')) ? -1 : 0
//         );
//         }
//         else if(uid.toUpperCase().includes("DATE"))
//         {
//          return arr.sort((a, b) =>
//          Date(a[uid]) < Date(b[uid]) ? 1 
//          :  Date(b[uid]) < Date(a[uid]) ? -1 : 0 );
//         }
//         else
//         {
//           return arr.sort((a, b) =>
//           a[uid] < b[uid] ? 1 :  b[uid] < a[uid] ? -1 : 0 );
//         }
//     }
//   };

  
//   const handleSearch = (e) => {

//     // debugger;
//      setPage(0);
//     // var tagType = e.target.nodeName;
//      var valueSrch = '';
//     // if (tagType == "INPUT")
//     valueSrch = e.target.value;
//     // else if (tagType == "SELECT")
//     //   valueSrch = e.currentTarget.value;
//      setFreeSearch(valueSrch);

//     handleSearchInCol(valueSrch, cols);//tagType
//   };

//   const handleSearchInCol = (valueSrch, colsData) => {
 
//     debugger;
//     var afterFilterData = [];

      
//       if (orginalData.length === 0)
//         setDataBefFilter(data); 
 
//         afterFilterData = orginalData;       
//         if(colsData != "")
//         {
//             colsData.map(col => {
//                 if(col.AddFilter && col.SelectedVals.length > 0)
//                     afterFilterData = afterFilterData.filter((filter) => (col.SelectedVals.find(val => val === filter[col.Id]) 
//                         || (col.SelectedVals.includes("") && filter[col.Id].length == 0 )));  

//             });     

//         }
 
//     debugger;
//     if(valueSrch.length > 0 )
//     { 
//        afterFilterData=  afterFilterData.filter(function(obj) {
//         return Object.keys(obj)
//                      .some(function(k) { 
//                                return obj[k] != null && obj[k].indexOf(valueSrch) !== -1; 
//                            });
//     });
//     }

//     setDataR(afterFilterData)

//     cols.map((col) => {
//         if(col.IsSumerize)
//              col.Sumerize = 0;
//       });

//     afterFilterData.map((item) => {
//         cols.map((col) => {
//             if(col.IsSumerize)
//                  col.Sumerize += Number(item[col.Id].replace(/,/g, ''))
//           });
//       })

//     // if (afterFilterData.length > 0) {
//     //   let copySumTotal = { totalRdr: 0, totalDln: 0, totalInv: 0, total: 0 }
//     //   afterFilterData.map((item) => {
//     //     copySumTotal.totalRdr += Number(item.totalRdr.replace(/,/g, ''))
//     //     copySumTotal.totalDln += Number(item.totalDln.replace(/,/g, ''))
//     //     copySumTotal.totalInv += Number(item.totalInv.replace(/,/g, ''))
//     //     copySumTotal.total += Number(item.total.replace(/,/g, ''))
//     //   })
//     //   setSumTotal(copySumTotal);
//     // }
//     setCount(afterFilterData.length);
//     setPage(0);

//   };

//   const onClearFiltersClick =() => {
//   //
//     // setSelected({ lstbld: [], lstflr: [], lstapp: [], lstaliasName:[], lstcellular:[],lstdocNum:[], lsttotalRdr:[], lsttotalDln:[], lsttotalInv:[], lsttotal:[] });
//     //setFreeSearch("");

//     //איפוס פילטרים
//     cols.map((col) => {
//     if(col.AddFilter)
//             col.SelectedVals = [];
//     });
//     setFreeSearch("");    

//     handleSearchInCol( "", "");
//   };

//   function FillCombo(res, id) {

//     // debugger;
//     var tempMap = [];
//     var mapCol = res.map(item => {
//       if (!tempMap.includes(item[id])) {
//         tempMap.push(item[id]);
//         return { value: item[id] };
//       }
//     });
    
//     tempMap.sort();
//     tempMap.unshift("הכל");
//     return tempMap;
//   }

  
  
//   const handleFirstPageButtonClick = (event) => {
//     onPageChange(event, 0);
//   };

//   const handleBackButtonClick = (event) => {
//     debugger;
//     if(page > 0)
//         onPageChange(event, page - 1);
//   };

//   const handleNextButtonClick = (event) => {
//      debugger;
//     if(page+1 < (Math.ceil(count / rowsPerPage)))
//       onPageChange(event, page + 1);
//   };

//   const handleLastPageButtonClick = (event) => {
//     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//   };

//   function onPageChange(event, newPage) {
//     setPage(newPage);
//   }

//   const onSelectPage = (event) => {  
     
//     debugger;
//     if(event.target.value == "--")
//       setRowsPerPage(getNumRowsInPage(''));
//     else
//       setRowsPerPage(event.target.value);
//     setPage(0);

//   }

// //   const onSelectViewPage = (event) => {
// //     var selected = event.target.value;
// //     setPageViewType(selected);
// //     var rowPerPage = getNumRowsInPage(selected);    
// //     setRowsPerPage(rowPerPage);
// //     setPage(0);
// //   }

//   const getNumRowsInPage = (pageViewType)  =>
//   {
//     // var res = 0;
//     // if(pageViewType == "2")
//     //   res = window.innerHeight / 24;
//     // else
//     var   res = window.innerHeight / 25;
//     return res;
//   }

   
//   const handleChangePage = (
//     // event: React.MouseEvent<HTMLButtonElement> | null,
//     // newPage: number,
//   ) => {
//     //setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (value
//     //event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
//   ) => {
//     setRowsPerPage(parseInt(value, rowsPerPage));
//     setPage(0);
//   };

//   //--

//   const ITEM_HEIGHT = 48;
//   const ITEM_PADDING_TOP = 20;
//   const MenuProps = {
//     PaperProps: {
//       style: {
//         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//         width: 280,
//       },
//     },
//   };


  
//   const handleChange = (uid, valToSet) => {

//     debugger;
//     //var uidFilter = "lst"+uid;

//     let colData = cols;
//     cols[uid].SelectedVals = valToSet;
//     SetCols(colData);
// //
//     // let allSelectedVals = { lstbld: uidFilter == "lstbld" ? valToSet : selected.lstbld
//     //           , lstflr: uidFilter == "lstflr" ? valToSet : selected.lstflr
//     //           , lstapp: uidFilter == "lstapp" ? valToSet : selected.lstapp
//     //           , lststt: uidFilter == "lststt" ? valToSet : selected.lststt
//     //           , lstaliasName: uidFilter == "lstaliasName" ? valToSet : selected.lstaliasName
//     //           , lstdocNum: uidFilter == "lstdocNum" ? valToSet : selected.lstdocNum
//     //           , lstcellular: uidFilter == "lstcellular" ? valToSet : selected.lstcellular };
 
//     debugger;
    
//     handleSearchInCol(freeSearch, colData);//"multySelect", 
//   };


  
//   const ExpoerExcel = async()  => {

//     try
//     {
//       debugger;
//       const fileType = "application/octet-stream";

//       const ws = XSLX.utils.json_to_sheet(data);// dataExcelArr orginalData
//       const wb = {Sheets: {'data':ws}, SheetNames:['data'] };
//       const wbout = XSLX.write(wb, {type:"array", bookType:"xlsx"});
//       const dataExcel = new Blob([wbout], {type: fileType });//excelBuffer
//       FileSaver.saveAs(dataExcel, "report2.xlsx");
//     }
//     catch(error)
//     {
//       debugger;
//       console.log(error);
//     }
//   };
 
  return (
    <div className="rpt"  >
        <ReportTable  cntrct={cntrct} cntComp={cntComp} currentKey={currentKey}
              reportParams={reportParams} colsParam={ColsParams} urlParam={url} 
              reportData={reportData} setReportData={setData} handleTab={handleTab}></ReportTable>
      {/* {loadingStt.length > 0 && <div className="loader-container"> <div className="spinner"></div> </div>}

      <tr className="trPagination" >

        <div className="pagination">
        <a> <button className="cls" onClick={() => ExpoerExcel()} style={{backgroundImage:"url('./images/icons-excel-48.png')",backgroundSize:"cover", width:"20px", height:"20px"}}> </button></a>
          <a>
            <select onChange={onSelectPage} onfocus="this.selectedIndex = -1;">
              <option value="--" selected>הצג שורות</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option> 
              <option value="25">25</option>
              <option value="30">30</option>
              <option value="35">35</option>
              <option value="40">40</option>
              <option value="45">45</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="99999">הכל</option>
            </select></a>       

          <a className="page-link" href="#" onClick={handleFirstPageButtonClick} disabled={page === 0}>&laquo;</a>
          <a className="page-link" href="#" onClick={handleBackButtonClick} disabled={page === 0}>&lt;</a>
          <a className="page-link" href="#" onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>&gt;</a>
          <a className="page-link" href="#" onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>&raquo;</a>


          <a>מספר שורות {new Intl.NumberFormat().format(data.length)}</a>
          <a>עמוד {page+1} מתוך {Math.ceil(count / Math.ceil(rowsPerPage))} </a>
        
          <a>  
          <button onClick={onClearFiltersClick}>נקה בחירה</button>
          <input className="txtFreeSrch" placeholder="חיפוש חופשי" value={freeSearch} onChange={(e) => handleSearch(e)}></input>
          </a>

        </div>
      </tr>
      <table id="tableRpt" className="Report">
        <thead>
          <tr>
          {cols.map((col, index) => {
              return (<th onDoubleClick={() => handleSort(col.Id)}> {col.Name}
             
                 {col.AddFilter ? <DialogSelect uid ={col.Id} index = {index} arrAll = {col.AllVals} arrSelected = {col.SelectedVals} positionL = "90%" 
                             setAfterSelect={handleChange}  listVals = {FillCombo(data, "bld")} ></DialogSelect> : '' }
                 {col.IsSumerize ? <div className="total-reports" style={{ color: cntComp == "CM" ? "purple" : "Teal" }}>
                                {new Intl.NumberFormat().format(col.Sumerize.toFixed(0))}</div> : ''}
                  </th>);
                })}         
          </tr>
        </thead>
        <tbody>
          {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data
          ).map((row) => (
             <tr >
                {cols.map((col, index) => { 
                    return (<td className="drName">{row[col.Id]}</td>);
                })}      
            </tr>
          ))}
        </tbody>
        <tfoot>
        </tfoot>
      </table> */}
    </div>

  );



};

export default Report1;